<template>
  <div class="orderContent">
    <navBar :title="topTitle"></navBar>
    <div class="shops box" v-for="(cItem,cIndex) in orderInfo.child" :key="cIndex">
      <div class="topTitle flexBetween">
        <div class="name">{{cItem.shop_name}}</div>
        <div class="status" v-if="cItem.order_status==16">待确认</div>
        <div class="status" v-if="cItem.order_status==26">配货中</div>
        <div class="status blue" v-if="cItem.order_status==27">待取货</div>
        <div class="status" v-if="cItem.order_status==40">已完成</div>
      </div>

<!--      <van-checkbox-group v-model="checkList[cIndex]">-->
      <div class="item flexBetween" v-for="(lItem,lIndex) in cItem.goods_list" :key="lIndex">
        <div class="imgBox">
          <img :src="lItem.sku_master_img" alt="">
        </div>
        <div class="itemInfo">
          <div class="name">{{lItem.sku_title}}</div>
          <div class="priceBox flexBetween">
            <div class="price">￥{{lItem.price}}</div>
            <div class="num">×{{lItem.qty}}</div>
          </div>
        </div>
<!--        <van-checkbox slot="right-icon" :name="lItem.id" ref="checkboxes" v-if="status==27" />-->
      </div>
<!--      </van-checkbox-group>-->

      <div class="compute flexBetween">
        <div class="btnBox">
          <van-button round color="#687BFF" v-if="status==26 || status==27" @click="surePick(cItem.id,cItem.order_status)">{{cItem.order_status==31?'确认送达':'确认收货'}}</van-button>
        </div>
        <div class="total">小计：<span>￥{{cItem.goods_amount}}</span></div>
      </div>
    </div>
    <div class="box delivery flexBetween">
      <div class="name">配送费</div>
      <div class="price">￥{{fee}}</div>
    </div>
    <!--拨打电话-->
    <div class="box flexBetween" v-if="orderInfo.order_address">
      <div class="left">
        <div class="address">{{orderInfo.order_address.address}}</div>
        <div class="info">{{orderInfo.order_address.contacts + ' ' +
          orderInfo.order_address.mobile}}
        </div>
      </div>
      <div class="phone" @click="contactUser"></div>
    </div>

    <!--订单信息-->
    <div class="infoCont box">
      <div class="orderSn flexBetween">
        <div class="name">订单号</div>
        <div class="value">{{orderInfo.order_sn}}
          <span v-clipboard:copy="orderInfo.order_sn" v-clipboard:success="copySuc"
                v-clipboard:error="copyFail">复制</span></div>
      </div>
      <div class="orderTime flexBetween">
        <div class="name">下单时间</div>
        <div class="value">{{orderInfo.create_time}}</div>
      </div>
      <div class="payWay flexBetween">
        <div class="name">支付方式</div>
        <div class="value">微信转账
          <van-button color="#687BFF" size="small" @click="showPayImg">支付凭证</van-button>
        </div>
      </div>
      <!--      <div class="wxName flexBetween">-->
      <!--        <div class="name">微信昵称</div>-->
      <!--        <div class="value">小小校叶子</div>-->
      <!--      </div>-->

    </div>

    <!--提交-->
    <van-button type="primary" block @click="sureOrder"
                :loading="loading"
                loading-type="circular"
                :loading-text="buttonText"
                color="#687BFF"
                :disabled="loading"
                v-if="status==16"
    >
      {{buttonText}}
    </van-button>

<!--    <van-button plain color="" block @click="pickerShow=true" color="#DE1919" v-if="status==27">-->
<!--      取货失败-->
<!--    </van-button>-->

    <!--取货失败弹框-->
<!--    <van-overlay :show="pickerShow" v-if="status==27">-->
<!--      <van-picker-->
<!--              show-toolbar-->
<!--              title="取货失败原因"-->
<!--              :columns="columns"-->
<!--              @cancel="pickerShow = false"-->
<!--              visible-item-count="3"-->
<!--              @confirm="pickerConfirm"-->
<!--      />-->
<!--    </van-overlay>-->
  </div>
</template>

<script>
  import navBar from "../../../components/navBar";
  import Vue from 'vue';
  import {Button, Dialog, Toast,Picker,Overlay,Checkbox,CheckboxGroup,ImagePreview } from 'vant';

  Vue.use(Button).use(Dialog).use(Toast).use(Picker).use(Overlay).use(Checkbox).use(CheckboxGroup).use(ImagePreview);
  export default {
    name: "orderContent",
    components: {
      navBar
    },
    data() {
      return {
        checkList:{},//选择结果
        pickerShow:false,//选择器显示
        columns:['店铺未开','缺货','其他'],//取货失败原因
        fee:'',//配送费
        topTitle: '',//头部页面标题（根据状态判断）
        status: '',//订单当前状态
        id: this.$route.query.id,
        buttonText: '',//按钮文字
        loading: false,//是否加载和按钮是否已点击状态共用
        orderInfo: ''//订单信息
      }
    },
    mounted() {
      this.getTopTitle();
      this.getOrderInfo();
    },
    methods: {
      showPayImg(){
        ImagePreview([
          this.orderInfo.pay_image
        ]);
      },
      //取货失败
      pickerConfirm(value){
        this.pickerShow = false;
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/marketexpressreceipt/fail`,
          data: {
            market_express_id: this.orderId,
            fail_msg:value
          }
        }).then(res=>{
          if(res.code=='0'){
            this.$router.push('/qjOrder');
          }
          Toast(res.msg)
        })
      },
      //订单提交
      sureOrder() {
        this.loading = true;
        //订单确认
        if (this.status == '16') {
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/communityorder/confirm`,
            data: {
              order_id: this.id
            }
          }).then(res => {
            this.loading = false;
            if (res.code == '0') {
              this.$router.push('/allOrder');
            }
            Toast(res.msg);
          })
        }
      },

      //确认取货
      surePick(id,status){
        if(this.status == '26' || this.status == '27'){

          if(status==31){
            this.$router.push({
              path:'/childOrderContent',
              query:{
                status,
                id
              }
            })
          }else{
            //订单取货完成
            this.sendHttp({
              method: 'post',
              url: `${this.orderUrl}/communityorder/pickup`,
              data: {
                id
              }
            }).then(res => {
              if (res.code == '0') {
                //取货完成重新获取当前订单信息
                this.getOrderInfo();
                if(!this.orderInfo.child || this.orderInfo.child.length==0){
                  this.$router.push('/allOrder');
                  Toast('该订单已全部完成取货');
                }
              }
              Toast(res.msg);
            })
          }
        }
      },
      //拨打电话
      contactUser() {
        Dialog.confirm({
          message: this.orderInfo.order_address.mobile,
          confirmButtonText: '呼叫'
        }).then(() => {
          window.location.href = `tel:${this.orderInfo.order_address.mobile}`;
        }).catch(() => {
          // on cancel
        });

      },
      //获取头部标题
      getTopTitle() {
        this.id = this.$route.query.id;
        this.status = this.$route.query.status;
        if (this.status == '16') {
          this.topTitle = '订单-待确认';
          this.buttonText = '确认已收款，发送订单给商家';
        } else if (this.status == '26') {
          this.topTitle = '订单-配货中';

        } else if (this.status == '27') {
          this.topTitle = '订单-待取货';

        } else if (this.status == '40') {
          this.topTitle = '订单-已完成';
        }
      },
      //获取当前订单详情
      getOrderInfo() {
        if (this.id) {
          //获取订单信息
          this.sendHttp({
            method: 'post',
            url: `${this.orderUrl}/communityorder/orderinfo`,
            data: {
              order_id: this.id
            }
          }).then(res => {
            console.log(res)
            if (res.code == '0') {
              this.orderInfo = res.data

              //获取配送费
              this.sendHttp({
                method: 'post',
                url: `${this.orderUrl}/delivery/communityfee`,
                data: {
                  amount: this.orderInfo.order_amount
                }
              }).then(res=>{
                if(res.code==0){
                  this.fee = res.data.fee;
                }
              })
            }
          })



        }
      },
      copySuc() {
        Toast('复制成功');
      },
      copyFail() {
        Toast('复制失败');
      }
    }
  }
</script>

<style scoped lang="less">
  .van-overlay{
    display: flex;
    align-items: flex-end;
    z-index:100;
  }
  .van-picker{
    width: 100%;
  }
  .van-tabs__nav--line {
    padding-bottom: 12px;
  }

  .van-tab {
    font-size: 16px;
  }

  .van-button--block {
    width: 347px;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    margin: 32px auto;
  }

  .van-button--round {
    min-width: 73px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }

  .orderContent {
    background: #f5f5f5;
    position: absolute;
    width: 100%;
    min-height: 100%;

    .box {
      background: #fff;
      margin-top: 6px;
      padding: 0 14px;

      .left {
        padding: 12px 0;

        .info {
          color: #8D95A6;
          font-size: 13px;
          line-height: 30px;
        }
      }

      .phone {
        width: 17px;
        height: 17px;
        background: url("../../../assets/images/phone.png") no-repeat;
        background-size: contain;
      }
    }

    .infoCont {
      line-height: 26px;
      padding: 10px 14px;

      .name {
        color: #8D95A6;
      }

      .value {
        span {
          padding-left: 10px;
          color: #fff;
          text-decoration: underline;
        }
      }
    }

    .delivery {
      height: 44px;
    }

    .shops {
      .topTitle {
        height: 44px;
        background: #fff;
        border-bottom: 1px solid #F5f5f5;

        .name {
          font-size: 12px;
          color: #666;
          padding-left: 24px;
          letter-spacing: 1px;
          background: url('../../../assets/images/ddpartner/shopsIcon.png') no-repeat left center;
          background-size: contain;
        }
        .blue{
          color: #687BFF;
        }
      }

      .item {
        position: relative;
        border-bottom: 1px solid #F5f5f5;
        padding: 9px 0;
        .van-checkbox{
          position: absolute;
          top: 32px;
          right: 20px;
        }
        .imgBox {
          background: #eee;
          width: 60px;
          height: 60px;
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .itemInfo {
          width: 270px;

          .priceBox {
            margin-top: 18px;

            .price {
              font-size: 16px;
              color: #DE1919;
            }
          }
        }
      }

      .compute {
        height: 44px;
      }
    }

  }

</style>
